import React from 'react';
import { TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import _ from 'lodash';

export type TSearchBoxProps = {
  label?: string;
  required?: boolean;
  onChange?: (query: string) => void;
  debounce?: number;
  defaultValue?: string;
  // Defaults to 360px because six of the seven callers lay out around that
  // width; only pass this when the field has to fit a narrower container.
  width?: string;
};

export const SearchTracking: React.FC<TSearchBoxProps> = (props) => {
  // Ref keeps the debounce instance stable across rerenders while still
  // calling the latest onChange; recreating it would cancel pending searches.
  const onChangeRef = React.useRef(props.onChange);
  onChangeRef.current = props.onChange;

  const searchValue = React.useMemo(
    () =>
      _.debounce(
        (value) => (onChangeRef.current ? onChangeRef.current(value) : value),
        props.debounce || 800,
      ),
    [props.debounce],
  );

  React.useEffect(() => {
    return () => {
      searchValue.cancel();
    };
  }, [searchValue]);

  return (
    <TextField
      // label={label}
      variant="outlined"
      placeholder={props.label ? props.label : 'Search for a title'}
      sx={{
        '& .MuiFormLabel-asterisk': {
          color: '#213B54',
        },
        input: {
          color: '#213B54',
          paddingLeft: '12px',
          '&::placeholder': {
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: '0.5px',
            opacity: 1,
          },
        },
        backgroundColor: '#EEF1F3',
        borderRadius: '28px',
        width: props.width || '360px',
        height: '56px',
        color: '#213B54',
        fontWeight: 500,
        fontSize: '15px',
        zIndex: 1,
        lineHeight: '24px',
        letterSpacing: '0.5px',
        border: 'none',
        fieldset: {
          border: 'none',
        },
      }}
      required={props.required}
      defaultValue={props.defaultValue}
      InputProps={{
        startAdornment: (
          <SearchIcon
            sx={{
              color: '#213B54',
            }}
          />
        ),
      }}
      onChange={(e) => searchValue(e.target.value)}
    />
  );
};
